var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"highscore"},[_c('GoodTable',{attrs:{"rows":_vm.rows}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }